import React from "react";
import SummarySection from "./SummarySection";
import ValidatorResults from "./ValidatorResults";
import PatientActions from "./PatientActions";

const PatientDetails = ({ patient, supportData, onPatientUpdate, refreshKey = 0 }) => {

  if (!patient || patient.error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4 mt-4">
        <p className="text-red-700">{patient?.error || "Patient not found."}</p>
      </div>
    );
  }

  return (
    <div key={patient.patient_id} className="mt-3 space-y-4">
      <SummarySection
        patient={patient}
        doctor={supportData.doctor}
        doctorLoading={supportData.loading.doctor}
        smartChart={supportData.smartChart}
        smartChartLoading={supportData.loading.smartChart}
        smartChartError={supportData.fetchErrors.smartChart}
        trace={supportData.trace}
        traceLoading={supportData.loading.trace}
        transcription={supportData.transcription}
        transcriptionLoading={supportData.loading.transcription}
        transcriptionError={supportData.fetchErrors.transcription}
        summarization={supportData.summarization}
        summarizationLoading={supportData.loading.summarization}
        summarizationError={supportData.fetchErrors.summarization}
        onPatientUpdate={onPatientUpdate}
      />
      <ValidatorResults
        validationContext={supportData.validationContext}
        isRunningValidators={supportData.isLoading}
      />
      <PatientActions patient={patient} refreshKey={refreshKey} />
    </div>
  );
};

export default PatientDetails;
